// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"20d3699e","237":"b5db9e23","260":"321f5310","284":"24ff81f9","452":"43a701d7","453":"2376e55a","457":"29abd554","469":"41939216","486":"c8de0b39"}[chunkId] + ".chunk.js";
};